import { SOCKET_URL } from "../api/socket";

let socket;
let reconnectTimer = null;
let isIntentionalClose = false;

export function connectOrderSocket(brandId, onOrder) {
  if (socket) {
    isIntentionalClose = true;
    socket.onclose = null; // detach old handler so it can't fire logic
    socket.close();
  }

  isIntentionalClose = false;
  socket = new WebSocket(SOCKET_URL);

  socket.onopen = () => {
    console.log("Merchant socket connected");
    clearTimeout(reconnectTimer); // <-- key fix: stop any pending reconnect
    socket.send(JSON.stringify({ type: "merchant_identify", brandId }));
  };

  socket.onmessage = (event) => {
    const data = JSON.parse(event.data);
    if (data.type === "NEW_ORDER") onOrder(data.order);
  };

  socket.onerror = (error) => {
    console.log("Socket error", error);
  };

  socket.onclose = () => {
    console.log("Merchant socket disconnected");
    if (isIntentionalClose) return; // don't auto-reconnect on purpose-driven closes

    clearTimeout(reconnectTimer);
    reconnectTimer = setTimeout(() => {
      console.log("Reconnecting merchant socket...");
      connectOrderSocket(brandId, onOrder);
    }, 5000);
  };
}

export function disconnectOrderSocket() {
  isIntentionalClose = true;
  clearTimeout(reconnectTimer);
  if (socket) {
    socket.onclose = null;
    socket.close();
    socket = null;
  }
}
